module.exports = __webpack_public_path__ + "static/media/apple_logo.8f6fc2f0.jpg";